var AdUnit = require('./AdUnit');

var AdSlot = require('./AdSlot');

var Campaign = require('./Campaign');

var Audience = require('./Audience'); // DODO: Remove


var itemClassByName = {
  AdUnit: AdUnit,
  AdSlot: AdSlot,
  Campaign: Campaign,
  Audience: Audience
};
module.exports = {
  itemClassByName: itemClassByName
};